<template>
<div>  
    <ArtistVideoSection />
    <!-- published Section -->
    <section class="page-section bg-light-orange" id="publishedsection">
        <!-- muncul pas gede aja -->
        <div class="container d-block">
            <h1 class="text-center mt-0 section-title">
                {{ $t('textAward1') }}
            </h1>
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-end award-wrapper">
                <a v-for="[index, award] of awards.entries()" :key="index" :href="award.url" class="award-block" target="_blank" dir="auto">
                    <img v-lazy="award.img" alt="award"/>
                    <div v-lazy:background-image="award.img"></div>
                    <p class="text-award" v-t="{ path: award.textKey }"></p>
                </a>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { createImageObject } from '@/utils/utils';
import ArtistVideoSection from './ArtistVideoSection';

export default {
   name: 'AwardSection',
   components: {
       ArtistVideoSection
   },
    mounted() {
       this.$nextTick(() => {
            // alert('published section finish loaded')
            this.$emit('isPublishedSection', 'publishedSectionActive')
        })
    },
    data() {
        return {
            awards: [
                {
                    img: createImageObject('./assets/img/awards/aw1.png'),
                    url: 'https://learn-quran.co/link/awardDistpUI',
                    textKey: 'textAward2',
                },
                {
                    img: createImageObject('./assets/img/awards/aw2.png'),
                    url: 'https://learn-quran.co/link/awardDeureuhamInstagramPost',
                    textKey: 'textAward3',
                },
                {
                    img: createImageObject('./assets/img/awards/aw3.png'),
                    url: 'https://learn-quran.co/link/awardBRINInstagram',
                    textKey: 'textAward2',
                },
                {
                    img: createImageObject('./assets/img/awards/aw4.png'),
                    url: 'https://learn-quran.co/link/awardUmmahWide2017',
                    textKey: 'textAward4',
                },
                {
                    img: createImageObject('./assets/img/awards/aw5.png'),
                    url: 'http://link.learn-quran.co/awardglobalsadaqahmaa',
                    textKey: 'textAward5',
                },
            ]
        }
    }
}
</script>

<style scoped>
.rounded-lg {
    border-radius: .5rem!important;
}
img {
    max-height:5rem;    
    max-width: 100%;
    transition: 0.3s;
}

img:hover {    
    opacity: 0.5;
}

.section-title {
    font-family: 'QuattrocentoRegular', 'Rubik', sans-serif;
    /* font-weight: 0!important; */
    color:#053448;
}

#publishedsection {
    padding-bottom: 0.1rem!important;
}

.padding-bottom-mini {
    padding-bottom: 3rem!important;
}

.award-wrapper {
    margin: 2.5rem 0;
    gap: 0 0.5rem;
}

.award-block {
    display: inline-block;
    text-align: center;
    max-width: 9rem;
}

@media (min-width: 720px) {
    .award-wrapper {
        gap: 0 2rem;
    }

    .award-block {
        max-width: 8.5rem;
    }
}

.text-award {
    color: #053448;
    font-weight: 500;
    font-family: 'RobotoBold', 'Rubik';
}
.text-award-last {
    font-size: 0.9rem;
}
a:hover {
    text-decoration: none;
}
.max-width-added {
    max-width: 9rem;
}
.bg-light-orange {
    background-color: #fff1ed !important;
}
.border-light-orange {
    border-color: #fff1ed !important;
}
</style>
